export const COLOURS = ['#f1e1d4', '#dac9ac', '#fadcd2', '#dfb6a4', '#c38a81', '#f5b381', '#dac3ba']
